import { render, staticRenderFns } from "./DashboardCommunitiesMine.vue?vue&type=template&id=a3167b78&"
import script from "./DashboardCommunitiesMine.vue?vue&type=script&lang=js&"
export * from "./DashboardCommunitiesMine.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports